import { skipToken, useQuery } from "@tanstack/react-query";
import { APIClient } from "lib/api/client";
import { useAPIClient } from "render/context/APIContext";

export function useSkinScannerStatusQuery({
  patientId,
  visitId,
}: {
  patientId: string | undefined;
  visitId: string | undefined;
}) {
  const apiClient = useAPIClient();

  return useQuery({
    queryKey: queryKey(patientId, visitId),
    queryFn:
      patientId != null && visitId != null
        ? queryFn(apiClient, patientId, visitId)
        : skipToken,
    refetchInterval: 5000,
  });
}

function queryFn(apiClient: APIClient, patientId: string, visitId: string) {
  return async function () {
    const visitDTO = await apiClient.visit.fetchSkinScannerStatus({
      patientId,
      visitId,
    }).result;

    return visitDTO;
  };
}

function queryKey(patientId: string | undefined, visitId: string | undefined) {
  return ["skinScannerStatus", patientId, visitId];
}
